export const formattedDrugName = (drugName, specificity) =>
  `${drugName}${specificity === 'GENERIC' ? ' (generic)' : ''}`;
